import request from '@/utils/qqMapRequest.js';

// 关键词输入提示
export function mapSuggestion(params) { 
    return request({
        url:'/ws/place/v1/suggestion',
        method:'GET',
        params
    })
 }

export function geocoder(params) { 
    return request({
        url:'/ws/geocoder/v1',
        method:'GET',
        params
    })
}

// 坐标转换
export function conversionTranslate(params){
    return request({
        url: "/ws/coord/v1/translate",
        method: "GET",
        params
    })
}



//  逆地址解析
// export function reAddressResolution(params) { 
//     return request({
//         url:'/ws/geocoder/v1',
//         method:'GET',
//         params
//     })
//  }

//  地址解析
// export function addressTextToObject(params) { 
//     return request({
//         url:'/ws/geocoder/v1',
//         method:'GET',
//         params
//     })
//  }

export function locationIp(params){
    return request({
      url: '/ws/location/v1/ip',
      method: 'GET',
      params
    })
  }